module.exports = __webpack_public_path__ + "img/EN-Wix-integration-vidjet-step3.ac37aa1e.png";